var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLineColumnCombo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#818490",
  d: "M1 23h23v1H0V0h1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4569A5",
  d: "M3 13.5h5V21H3zm7-5h5V21h-5zm7 2.5h5v10h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#97C2EA",
  fillRule: "nonzero",
  d: "M18.373 2.71a1.25 1.25 0 1 1-.036.999l-4.622-.165a1.25 1.25 0 0 1-2.254.401L6.75 5.796a1.25 1.25 0 1 1-.366-.93l4.906-1.927a1.25 1.25 0 0 1 2.237-.403z"
}))));
export default SvgLineColumnCombo;